export const desktopMinWidth = 1024;
export const tabletMinWidth = 768;
export const smMobileMinWidth = 320;
export const lgMobileMinWidth = 425;
export const maxContentWidth = 960;